// NavRail.jsx
// Tablet-tier navigation: a slim icon rail (Material 3 "medium" window class /
// the collapsible-sidebar pattern most pro web apps use). Reuses the SAME nav
// data as the desktop Sidebar (staticdata → sidebarmenu); icon-only with a
// tooltip label, grouped with hairline separators. Touch-friendly targets.
import React from "react";
import { Link, NavLink } from "react-router-dom";
import { sidebarmenu } from "../../data/staticdata";
import brandMark from "../../data/logo-icon-light.png";
import { useAuth } from "../../contexts/AuthContext";
import { filterAdminOnly } from "./adminOnly";

export const RAIL_WIDTH = 64;

export default function NavRail() {
  const { user } = useAuth();
  return (
    <nav
      aria-label="Primary"
      style={{
        width: RAIL_WIDTH,
        flex: `0 0 ${RAIL_WIDTH}px`,
        height: "100vh",
        position: "sticky",
        top: 0,
        background: "var(--bg-2)",
        borderRight: "1px solid var(--divider)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowY: "auto",
        overflowX: "hidden",
        paddingBottom: 16,
        zIndex: 40,
      }}
      className="no-scrollbar"
    >
      {/* Brand mark → home */}
      <Link
        to="/"
        aria-label="DeeTrade home"
        style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 56, flex: "0 0 auto" }}
      >
        <img src={brandMark} alt="" aria-hidden="true" style={{ width: 30, height: 30, display: "block" }} />
      </Link>

      {sidebarmenu.map((group, gi) => (
        <React.Fragment key={group.title}>
          {gi > 0 && (
            <div style={{ width: 28, height: 1, background: "var(--divider)", margin: "6px 0", flex: "0 0 auto" }} />
          )}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, width: "100%" }}>
            {filterAdminOnly(group.links, user).map((link) => (
              <NavLink
                key={link.name}
                to={`/${link.name}`}
                end={link.end}
                title={link.displayName || link.name}
                aria-label={link.displayName || link.name}
                style={({ isActive }) => ({
                  width: 44,
                  height: 44,
                  flex: "0 0 auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 10,
                  fontSize: 20,
                  color: isActive ? "var(--color-accent)" : "var(--fg-2)",
                  background: isActive ? "rgba(var(--color-accent-rgb), 0.14)" : "transparent",
                  transition: "background 120ms var(--ease-standard, ease), color 120ms",
                })}
              >
                <span style={{ display: "flex", opacity: 0.9 }}>{link.icon}</span>
              </NavLink>
            ))}
          </div>
        </React.Fragment>
      ))}
    </nav>
  );
}
